import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { NgCommonModule } from '@principle-theorem/ng-shared';
import {
  MockAllTeeth,
  toothRefToLabel,
} from '@principle-theorem/principle-core';
import {
  ACC_BOOLEAN_DISPLAY_MAP,
  AccAlveolusInjury,
  AccBooleanValue,
  AccCariesActivity,
  AccCondition,
  AccDeglovingInjury,
  AccJawInjury,
  AccProsthesisType,
  AccSoftTissueHow,
  AccTmjInjury,
  AccToothInjuryClassification,
  AccToothNumber,
  AccToothPreAccidentCondition,
} from '@principle-theorem/principle-core/interfaces';
import { AccDiagnosisDetailsFormGroup } from '../../form-groups/acc-dental-diagnosis.formgroup';
import { toOptions } from '@principle-theorem/shared';

@Component({
  selector: 'pr-acc-dental-diagnosis-form',
  imports: [
    NgCommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatRadioModule,
    MatSelectModule,
    MatDividerModule,
    MatButtonModule,
    MatChipsModule,
    MatIcon,
  ],
  templateUrl: './acc-dental-diagnosis-form.component.html',
  styleUrls: ['./acc-dental-diagnosis-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccDentalDiagnosisFormComponent {
  form = input.required<AccDiagnosisDetailsFormGroup>();
  disabled = input<boolean>(false);

  readonly booleanDisplay = ACC_BOOLEAN_DISPLAY_MAP;
  readonly booleanOptions = toOptions(AccBooleanValue);
  readonly prosthesisTypes = toOptions(AccProsthesisType);
  readonly softTissueHowOptions = toOptions(AccSoftTissueHow);
  readonly deglovingInjuryOptions = toOptions(AccDeglovingInjury);
  readonly alveolusInjuryOptions = toOptions(AccAlveolusInjury);
  readonly jawInjuryOptions = toOptions(AccJawInjury);
  readonly tmjInjuryOptions = toOptions(AccTmjInjury);
  readonly conditionOptions = toOptions(AccCondition);
  readonly cariesActivityOptions = toOptions(AccCariesActivity);

  readonly toothInjuryClassificationOptions = toOptions(
    AccToothInjuryClassification
  ).sort();

  readonly toothPreAccidentConditionOptions = toOptions(
    AccToothPreAccidentCondition
  ).sort();

  readonly toothNumberOptions: AccToothNumber[] = MockAllTeeth()
    .map(
      (tooth) => parseInt(toothRefToLabel(tooth.toothRef), 10) as AccToothNumber
    )
    .sort();
}
